import { LEGAL } from '@shared/constants/legal-info';
import { JsonLd } from '../JsonLd';

export function LocalBusinessLd() {
  const data: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    '@id': 'https://solutionecofrance.fr/#business',
    name: 'Solution Éco France',
    image: 'https://solutionecofrance.fr/logo.svg',
    url: 'https://solutionecofrance.fr',
    email: LEGAL.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: LEGAL.headquarters.street ?? '',
      addressLocality: LEGAL.headquarters.city ?? '',
      postalCode: LEGAL.headquarters.postalCode ?? '',
      addressCountry: 'FR',
    },
    priceRange: 'Sur devis — modèle économique transparent',
    areaServed: 'France',
  };
  if (LEGAL.phone) {
    data.telephone = LEGAL.phone;
  }
  return <JsonLd schema={data} />;
}
